import { createSelector } from 'reselect';

import permissionConstants from 'xm-constants/permissions';

import { hasAnyPermission } from 'utils/permissions';
import {
  selectFeatureToggleMap,
  pruneItemsAndGroups,
  selectPermissions,
} from './util';

function getGroupsNav(permissions, featureToggleMap) {
  const groupPerformanceReport = {
    id: 'NAV_GROUP_PERFORMANCE',
    to: 'GroupPerformance/alerts',
    permission: permissionConstants.VIEW_MENUITEM_GROUP_PERFORMANCE_REPORT,
    selectorId: 'GroupPerformance',
  };

  const isReactDynamicGroupsUIEnabled =
    featureToggleMap.REACT_DYNAMIC_GROUPS_UI === 'true';

  const navItemGroups = [
    {
      id: 'NAV_MANAGE_GROUPS',
      items: [
        {
          id: 'NAV_GROUPS',
          to: 'groups',
          permission: permissionConstants.VIEW_MENUITEM_GROUPS,
          selectorId: 'GroupsPlace',
        },
        { ...groupPerformanceReport },
        {
          id: 'NAV_WHOS_ON_CALL',
          to: 'WhosOnDutyGroupSelectionPlace:',
          permission: permissionConstants.VIEW_SCREEN_WHOS_ON_DUTY,
          selectorId: 'WhosOnDutyGroupSelectionPlace',
        },
        {
          id: 'NAV_HISTORICAL_ON_CALL',
          to: 'HistoricalOnCallPlace:',
          permission: perms =>
            hasAnyPermission(
              perms,
              permissionConstants.VIEW_SCREEN_HISTORICAL_ONCALL,
              permissionConstants.VIEW_MENUITEM_COMPANY_ADMINS,
            ),
          selectorId: 'HistoricalOnCallPlace',
        },
      ],
    },
    !isReactDynamicGroupsUIEnabled && {
      id: 'NAV_TEAMS',
      items: [
        {
          id: 'NAV_DYNAMIC_TEAMS',
          to: 'DynamicTeams',
          permission: permissionConstants.VIEW_MENUITEM_DYNAMIC_TEAMS,
          selectorId: 'DynamicTeams',
        },
      ],
    },
  ];

  return pruneItemsAndGroups(navItemGroups, permissions);
}

export default createSelector(
  [selectPermissions, selectFeatureToggleMap],
  getGroupsNav,
);
